// extracted by mini-css-extract-plugin
export default {"content":"BillingDetailsPage_content__UF6FF"};